import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DepositModalService {

  private selectedDepositSubject = new BehaviorSubject<any>(null);
  public selectedDeposit$ = this.selectedDepositSubject.asObservable();

  constructor() { }

  setSelectedDeposit(deposit: any): void {
    this.selectedDepositSubject.next(deposit);
  }

  getSelectedDeposit(): any | null {
    return this.selectedDepositSubject.value;
  }

  clearSelectedDeposit(): void {
    this.selectedDepositSubject.next(null);
  }
}

